import styled from "styled-components";

import { Dialog, IconButton } from "@libraries/mui";

import { windowWidth } from "@styles/global";

// Telluria
import { Button } from "@npm-telluria-tecnologia/telluria-ui";

const Container = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 10px !important;
    min-width: 400px !important;
    max-width: 400px !important;
    min-height: 450px !important;

    @media (max-width: ${windowWidth.mobile.large}) {
      min-width: 95% !important;
    }
  }

  .MuiDialogContent-root {
    padding: 0 24px !important;
  }
`;

const DialogActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const SubmitContractButton = styled(Button)`
  background-color: ${(props) => props.theme.colors.primary} !important;
  font-size: 12px !important;
  padding: 5px 15px !important;

  :hover {
    background-color: ${(props) => props.theme.colors.secondary} !important;
  }
`;

const ContractListContainer = styled.div`
  margin-top: 16px;
`;

const CustomIconButton = styled(IconButton)`
  position: absolute !important;
  right: 8px;
  top: 11px;
  color: ${({ theme }) => theme.colors.primary} !important;
`;

export {
  Container,
  DialogActions,
  ContractListContainer,
  CustomIconButton,
  SubmitContractButton
};
